import { render, staticRenderFns } from "./ListagemFornecedor.vue?vue&type=template&id=2aa903ec&"
import script from "./ListagemFornecedor.vue?vue&type=script&lang=js&"
export * from "./ListagemFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports